import { render, staticRenderFns } from "./NsAvatar.vue?vue&type=template&id=9fdde900&"
import script from "./NsAvatar.vue?vue&type=script&lang=js&"
export * from "./NsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fdde900')) {
      api.createRecord('9fdde900', component.options)
    } else {
      api.reload('9fdde900', component.options)
    }
    module.hot.accept("./NsAvatar.vue?vue&type=template&id=9fdde900&", function () {
      api.rerender('9fdde900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsAvatar.vue"
export default component.exports